module.exports = __webpack_public_path__ + "assets/带看数量.06dbc073.svg";